export default __webpack_public_path__ + "static/oberon-eb-app-intro-f86f5cb1bf6b834544ec8745dd207cc8.jpg";